/**
 * Commands Page — Non-interactive allowlist-based command execution.
 * Replaces the removed WebSocket/xterm Terminal page.
 *
 * Displays available commands from the server-side Command_Allowlist,
 * allows parameter input per schema, and shows OTP-confirmed results.
 * No free command input, no shell, no WebSocket.
 */

import { useState, useEffect } from 'preact/hooks';
import { apiGet, apiPost } from '../lib/api';

interface CommandEntry {
  commandId: string;
  operationId: string;
  maxRuntimeSeconds: number;
  parameterSchema: Record<string, unknown>;
}

export function Commands() {
  const [commands, setCommands] = useState<CommandEntry[]>([]);
  const [selectedServer, setSelectedServer] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadCommands();
  }, [selectedServer]);

  async function loadCommands() {
    if (!selectedServer) { setLoading(false); return; }
    setLoading(true);
    try {
      const res = await apiGet(`/api/catalog/commands?targetServerId=${selectedServer}`) as any; // typed(`/api/catalog/commands?targetServerId=${selectedServer}`);
      setCommands(res.commands ?? []);
      setError('');
    } catch (err: any) {
      setError(err.message ?? 'Laden fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div class="page commands-page">
      <h2>Commands</h2>
      <p class="info-text">
        Einzelne freigegebene Diagnose-Commands ausführen. Keine freie Eingabe.
      </p>

      <select
        value={selectedServer}
        onChange={(e) => setSelectedServer((e.target as HTMLSelectElement).value)}
        aria-label="Zielserver auswählen"
      >
        <option value="">Server wählen...</option>
        <option value="gateway">Gateway</option>
        <option value="bm_613">BM-613</option>
        <option value="mail_server">Mail-Server</option>
      </select>

      {loading && <p>Laden...</p>}
      {error && <p class="error">{error}</p>}

      {!loading && commands.length === 0 && selectedServer && (
        <p>Keine Commands für diesen Server verfügbar.</p>
      )}

      {commands.map((cmd) => (
        <div key={cmd.commandId} class="command-card">
          <strong>{cmd.commandId}</strong>
          <span class="meta">Max. {cmd.maxRuntimeSeconds}s</span>
        </div>
      ))}
    </div>
  );
}
